import EnquiryEditor, { type EnquiryEditorProps } from "./editor";

export default function RequestForm(props: EnquiryEditorProps) {
  return <EnquiryEditor {...props} />;
}
